import Amplify, { Hub, Auth } from 'aws-amplify';
import config from './config';

const SESSION_BEGAN_TIMESTAMP_SECONDS_KEY = 'SESSION_BEGAN_TIMESTAMP_SECONDS';

// See options schema https://docs.amplify.aws/lib/auth/start/q/platform/js#re-use-existing-authentication-resource
function configureAmplify(options: any) {
  Amplify.configure({
    Auth: options,
  });
}

// This function only allows one login listener to be registered at a time
let loginListener: (data: any) => void;
function registerLoginListener(callback: (data: any) => void) {
  if (loginListener) {
    Hub.remove('auth', loginListener);
  }
  Hub.listen('auth', (loginListener = callback));
}

async function getUserAsync() {
  try {
    return await Auth.currentAuthenticatedUser();
  } catch (e) {
    return null;
  }
}

function setSessionStartTime(): void {
  localStorage.setItem(
    SESSION_BEGAN_TIMESTAMP_SECONDS_KEY,
    (Date.now() / 1000).toFixed(),
  );
}

function clearSessionStartTime(): void {
  localStorage.removeItem(SESSION_BEGAN_TIMESTAMP_SECONDS_KEY);
}

function getSessionStartTime(): number {
  const sessionStartTime = localStorage.getItem(
    SESSION_BEGAN_TIMESTAMP_SECONDS_KEY,
  ) as string;
  if (sessionStartTime !== null && !Number.isNaN(Number(sessionStartTime))) {
    return parseInt(sessionStartTime, 10);
  }
  return 0;
}

function getRemainingSessionTime(): number {
  const sessionStartedAt = getSessionStartTime();
  const now = Date.now() / 1000;
  const sessionExpiresAt = sessionStartedAt + config.app.sessionTimeout;
  return sessionExpiresAt - now;
}

function isSessionExpired(): boolean {
  return getRemainingSessionTime() < 0;
}

async function isAuthenticatedAsync(): Promise<boolean> {
  return (await getUserAsync()) !== null;
}

async function handleExpiredSessionAsync(): Promise<boolean> {
  const authenticated = await isAuthenticatedAsync();
  if (isSessionExpired() && authenticated) {
    Auth.signOut();
    clearSessionStartTime();
    return true;
  }
  console.log(
    `Session time remaining: ${getRemainingSessionTime().toFixed()}s.`,
  );
  console.log('Renewing session.');
  return false;
}

export {
  configureAmplify,
  registerLoginListener,
  getUserAsync,
  setSessionStartTime,
  clearSessionStartTime,
  handleExpiredSessionAsync,
};
